import {
    ActionReducerMap,
    combineReducers,
    createReducer,
    on,
    Action,
} from "@ngrx/store";
import { SnowflakeState, Statistics } from "./state";
export * from "./state";
import * as Actions from "./actions";
export { Actions as Actions };
import { RequestHandler } from "../common/state";

export const snowflakeStateFeatureKey = "snowflakeState";

const initialStatisticsState: Statistics = <Statistics>{};

export const getStatisticsReducer = createReducer(
    initialStatisticsState,
    on(Actions.getStatisticsSuccess, (currState, payload) => ({
        ...currState,
        domainQueries: payload.data.domainQueries,
        trendingSites: payload.data.trendingSites,
        sitesQueries: payload.data.sitesQueries,
        businessUnitsQueries: payload.data.businessUnitsQueries,
    })),
    on(Actions.getStatisticsFailure, (currState, payload) => ({
        ...currState,
    })),
);

const reducerMap: ActionReducerMap<SnowflakeState> = {
    statisticsData: getStatisticsReducer,
};

const snowflakeSubReducer = combineReducers(reducerMap);

export function snowflakeReducer(state: SnowflakeState, action: Action) {
    return snowflakeSubReducer(state, action);
}
